import { Link } from "@caprikorn/dynamo-ui";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { Link as RouterLink, generatePath } from "react-router-dom";

import { ROUTES } from "@router/router.constants";
import type { Customer } from "@services/apiEcms/apiEcms.types";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

const columnHelper = createColumnHelper<Customer>();

export const usePerimeterCustomersTableColumns = () => {
  const { t } = useCustomTranslation("main");
  const columns = useMemo(
    () => [
      columnHelper.accessor("companyName", {
        header: t("perimeter.customers.columns.companyName"),
        meta: { isHighlighted: true },
        cell: ({ getValue, row }) => (
          <Link
            as={RouterLink}
            hasNoDecoration
            to={generatePath(ROUTES.PERIMETER_CONTRACTS_BY_CUSTOMER, {
              customerId: row.original.customerId,
            })}
          >
            {getValue()}
          </Link>
        ),
        enableSorting: false,
      }),
      columnHelper.accessor("customerId", {
        header: t("perimeter.customers.columns.customerId"),
        enableSorting: false,
      }),
      columnHelper.accessor("siren", {
        header: t("perimeter.customers.columns.siren"),
        enableSorting: false,
      }),
    ],
    [t],
  );

  return columns;
};
